module.exports = __webpack_public_path__ + "img/esg-rz-pingan.227640c1.png";